(function(angular) {
    'use strict';

    angular.module('wtApp.AbstractModal', [])
        .constant('ABSTRACT_MODAL_CONST', {});
})(window.angular);

